import { z } from "zod";

/**
 * Staff payouts through PayMongo (Luigi, Decision Log 2026-10-08).
 *
 * The account is entered fresh on every request and never saved. The bank is
 * sent as PayMongo's code only; the server looks the name up from PayMongo's
 * own list, so the app cannot label a transfer with a bank it did not choose.
 */

const otpCode = z.string().regex(/^\d{6}$/, "Enter the 6-digit code.");

export const startStaffPhoneSchema = z.object({
  phone: z.string().trim().min(10, "Enter your mobile number.").max(20),
});
export type StartStaffPhoneInput = z.infer<typeof startStaffPhoneSchema>;

export const confirmStaffPhoneSchema = z.object({ code: otpCode });
export type ConfirmStaffPhoneInput = z.infer<typeof confirmStaffPhoneSchema>;

export const requestPayoutSchema = z.object({
  bankCode: z.string().trim().min(1, "Choose a bank or e-wallet.").max(64),
  accountName: z.string().trim().min(2, "Enter the name on the account.").max(120),
  // Digits only: a bank or e-wallet account number, as written on the account.
  accountNumber: z
    .string()
    .trim()
    .regex(/^\d{4,34}$/, "Enter the account number using digits only."),
});
export type RequestPayoutInput = z.infer<typeof requestPayoutSchema>;

export const verifyPayoutSchema = z.object({
  requestId: z.string().uuid(),
  code: otpCode,
});
export type VerifyPayoutInput = z.infer<typeof verifyPayoutSchema>;

export const payoutIdSchema = z.object({ requestId: z.string().uuid() });
export type PayoutIdInput = z.infer<typeof payoutIdSchema>;
